'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams, useRouter } from 'next/navigation';
import type { ImportQueueController } from '@lib/import-queue-ui/types/import-queue-controller';
import type { ImportQueueStatus } from '@lib/import-queue-ui/types/import-queue-status';
import { useTemplateBulkImport } from '../context/template-bulk-import-context';
import { buildTemplateDocsPath } from '../utils/build-template-docs-path';
import { pickTemplateIdFromParams } from '../utils/pick-template-id-from-params';
import { templateQueueItemToImportQueueItem } from '../utils/template-queue-item-to-import-queue-item';
const TEMPLATE_STATUS_LABEL_OVERRIDE: Partial<Record<ImportQueueStatus, string>> = {
  preparing: 'Creating template',
  done: 'Complete'
};
export function useTemplateBulkImportController() {
  const $ = _c(13);
  const router = useRouter();
  const params = useParams();
  const t0 = params?.template_id;
  let t1;
  if ($[0] !== t0) {
    t1 = pickTemplateIdFromParams(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeNavigationId = t1;
  const {
    queue,
    hasActiveWork,
    retryItem
  } = useTemplateBulkImport();
  let t2;
  if ($[2] !== queue) {
    t2 = queue.map(templateQueueItemToImportQueueItem);
    $[2] = queue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const items = t2;
  let t3;
  if ($[4] !== queue || $[5] !== router) {
    t3 = clicked => {
      const source = queue.find(q => q.clientId === clicked.clientId);
      if (source && source.status === "done" && source.dealId && source.packageId) {
        router.push(buildTemplateDocsPath(source.dealId, source.packageId));
      }
    };
    $[4] = queue;
    $[5] = router;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeNavigationId || $[8] !== hasActiveWork || $[9] !== items || $[10] !== retryItem || $[11] !== t3) {
    t4 = {
      domainKey: "templates",
      title: "Template imports",
      subtitle: "Open or switch templates from this batch",
      items,
      hasActiveWork,
      retryItem,
      activeNavigationId,
      statusLabelOverride: TEMPLATE_STATUS_LABEL_OVERRIDE,
      onItemClick: t3
    };
    $[7] = activeNavigationId;
    $[8] = hasActiveWork;
    $[9] = items;
    $[10] = retryItem;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}